export const juniorSalesPlanningResume = `
【職務概要】
営業企画として約3年間、主に事業戦略の立案から販売促進施策の企画・実行まで一連の業務に従事してきました。特に環境配慮型商品の市場導入や新規事業領域における営業戦略構築に注力し、データ分析に基づいた意思決定支援を得意としています。前職の経験を通じて培った市場分析力とマーケティング知識を活かし、顧客インサイトを捉えた提案型の営業企画を推進してきました。

昨今の業界トレンドである『デジタルマーケティング』を活用した顧客接点の創出に力を入れており、従来型の営業手法とデジタルを融合させたハイブリッド型の営業戦略の構築に取り組んでいます。市場環境の変化に柔軟に対応しながら、企業の持続的成長に貢献できる営業企画担当として、常に新たな知見を吸収し、更なるスキル向上に努めています。

【職務経歴】
株式会社AlgomaticソリューションズJapan（2021年4月〜現在）
・会社概要：法人向けコンサルティングサービスを提供する独立系企業。従業員数約150名。
・職務内容：営業企画担当
  ○ 営業戦略の立案・実行
    - 年間・四半期ごとの販売計画策定と進捗管理
    - 顧客データ分析に基づくターゲティング戦略策定
    - 競合分析およびベンチマーキングによる戦略改善提案
  ○ 販売促進企画
    - ウェビナーイベントの企画・運営（月1回・平均参加者100名）
    - 営業資料・提案書のテンプレート作成および定期的な更新
    - セールスチーム向け商品勉強会の実施（四半期に1回）
  ○ マーケティング施策の推進
    - リード獲得のためのデジタルマーケティング施策の立案・実行
    - メールマーケティングキャンペーンの企画・分析（開封率前年比15%向上）
・成果：
  ○ 新規開拓営業チームの目標達成率が前年比120%へ向上
  ○ マーケティング活動によるリード獲得数が前年比35%増加
  ○ 商談化率の向上（18%→25%）に貢献

株式会社Algomaticテクノロジー（2020年4月〜2021年3月）
・会社概要：ITソリューションおよびサービスを提供する企業。従業員数約80名。
・職務内容：マーケティング担当
  ○ コンテンツマーケティングの企画・実行
    - 自社サービス紹介資料の作成・更新
    - ブログ記事企画・執筆（月4本）
    - SNS運用（LinkedIn、Twitter）
  ○ 展示会・セミナー企画
    - 業界展示会での出展企画（年3回）
    - 自社セミナーの企画・集客・運営サポート
・成果：
  ○ デジタルマーケティング施策による問い合わせ数30%増加
  ○ 展示会からの案件創出が前年比20%向上
  ○ コーポレートサイト訪問者数の増加（月間5,000→8,000）

【受賞・表彰歴】
・2022年度 株式会社AlgomaticソリューションズJapan 優秀企画賞
  営業部門の組織改革プロジェクトにおける企画立案と実行が評価される
・2023年度 顧客満足度向上プログラム貢献賞
  顧客フィードバックを活用した営業プロセス改善の取り組みが評価される

【資格】
・2021年6月 中小企業診断士（一次試験合格）
・2022年9月 ITパスポート
・2023年4月 マーケティング・ビジネス実務検定 A級
・2023年12月 Google アナリティクス認定資格
・2024年3月 Salesforce認定アドミニストレーター

【マネジメント経験】
・営業企画プロジェクトチームのリーダー（2022年10月〜2023年3月）
  ○ 4名のメンバーをとりまとめ、新規事業向け営業戦略立案プロジェクトを推進
  ○ プロジェクト期間中の目標設定、タスク管理、進捗報告を担当
  ○ プロジェクト完遂により、新規事業の営業活動開始から3ヶ月で目標達成率95%を実現

【語学力】
・英語：ビジネスレベル
  ○ TOEIC 820点（2022年5月取得）
  ○ 海外顧客向け提案資料の作成、英語ウェビナーの企画・運営経験あり
  ○ グローバルプロジェクトにおける海外チームとの週次ミーティング進行
` as const;
